import React from 'react';
import { useSelector } from 'react-redux';
import cn from 'classnames';
import styles from '../styles/frame/frame.module.scss';
import Main from './main';
// import StakeSettings from './stake/stake-settings';
// import StakeDetails from './stake/stake-details';
// import StakeConfirm from './stake/stake-confirm';
// import StakeSuccess from './stake/stake-success';
import UnstakeSettings from './unstake/unstake-settings';
import UnstakeDetails from './unstake/unstake-details';
import UnstakeConfirm from './unstake/unstake-confirm';
import UnstakeSuccess from './unstake/unstake-success';
import WithdrawDetails from './withdraw/withdraw-details';
import WithdrawConfirm from './withdraw/withdraw-confirm';
import WithdrawSuccess from './withdraw/withdraw-success';
import ClaimDetails from './claim/claim-details';
import ClaimConfirm from './claim/claim-confirm';
import ClaimSuccess from './claim/claim-success';
import Error from './error';
import { useGetTheme } from '../../../../../hooks/useGetTheme';
import ClosedStub from './closed-stub';

const RoyaUniFrame = () => {
  const dark = useSelector((state) => state.basic.dark);
  const colors = useGetTheme();

  const { status, stakeBalance, unstakedBalance, rewardEarned, rewardBalance } = useSelector(
    (state) => state.ROYAUNIstake.stake,
  );

  const isBalancePositive = [stakeBalance, unstakedBalance, rewardEarned, rewardBalance].some(
    (value) => value !== '0',
  );

  return (
    <div
      className={cn(styles.cardContainer, { [styles.dark]: dark })}
      style={{ color: colors.text, backgroundColor: colors.stakingFrameBackground }}
    >
      {!isBalancePositive ? <ClosedStub /> : null}

      {isBalancePositive && status === 0 ? <Main /> : null}

      {/*{[stakeBalance, unstakedBalance, rewardEarned].some((value) => value !== '0') &&*/}
      {/*status === 0 ? (*/}
      {/*  <Main />*/}
      {/*) : null}*/}

      {/*{[stakeBalance, unstakedBalance, rewardEarned].every(*/}
      {/*  (value) => value === '0' && status === 0,*/}
      {/*) || status === 1 ? (*/}
      {/*  <StakeSettings />*/}
      {/*) : null}*/}

      {/*{status === 2 ? <StakeDetails /> : null}*/}
      {/*{status === 3 ? <StakeConfirm /> : null}*/}
      {/*{status === 4 ? <StakeSuccess /> : null}*/}

      {status === 20 ? <UnstakeSettings /> : null}
      {status === 21 ? <UnstakeDetails /> : null}
      {status === 22 ? <UnstakeConfirm /> : null}
      {status === 23 ? <UnstakeSuccess /> : null}

      {status === 30 ? <ClaimDetails /> : null}
      {status === 31 ? <ClaimConfirm /> : null}
      {status === 32 ? <ClaimSuccess /> : null}

      {status === 40 ? <WithdrawDetails /> : null}
      {status === 41 ? <WithdrawConfirm /> : null}
      {status === 42 ? <WithdrawSuccess /> : null}

      {status === 99 ? <Error /> : null}
    </div>
  );
};

export default RoyaUniFrame;
